import { render } from "./formEditEstudo.vue?vue&type=template&id=14da11a9"
import script from "./formEditEstudo.vue?vue&type=script&lang=js"
export * from "./formEditEstudo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__